/* istanbul ignore file */
import { number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const TierAdvancedMaxStudentsSettingParser = 
/* #__PURE__ */ parsers.object([
    ['name', /* #__PURE__ */ parsers.exactly('TIER_ADVANCED_MAX_STUDENTS')],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
]);
export class TierAdvancedMaxStudentsSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return TierAdvancedMaxStudentsSettingParser.decode(input).map(res => new TierAdvancedMaxStudentsSetting(res));
    }
    static unsafeDecode(input) {
        return TierAdvancedMaxStudentsSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return TierAdvancedMaxStudentsSettingParser.encode(data);
    }
    static schema() {
        return TierAdvancedMaxStudentsSettingParser.schema();
    }
}
